import {gql} from '@apollo/client'

export const orderFragment = gql`
  fragment OrderFields on Order {
    id
    created
    status
    subtotal {
      net {
        amount
      }
      gross {
        amount
      }
    }
    shippingPrice {
      net {
        amount
      }
      gross {
        amount
      }
    }
    total {
      net {
        amount
      }
      gross {
        amount
      }
    }
    billingAddress {
      id
      firstName
      lastName
      companyName
      streetAddress1
      city
      postalCode
    }
    shippingAddress {
      id
      firstName
      lastName
      companyName
      streetAddress1
      city
      postalCode
    }
    shippingMethod {
      id
      name
    }
    token
    lines {
      id
      variant {
        id
        name
        sku
        pricing {
          price {
            net {
              amount
            }
            gross {
              amount
            }
          }
        }
        product {
          id
          name
          slug
          thumbnail {
            url
            alt
          }
          thumbnail2x: thumbnail(size: 510) {
            url
          }
        }
      }
      quantity
      totalPrice {
        net {
          amount
        }
        gross {
          amount
        }
      }
    }
    metadata {
      key
      value
    }
  }
`

export const orderQuery = gql`
  ${orderFragment}
  query Order($token: UUID!) {
    orderByToken(token: $token) {
      ...OrderFields
    }
  }
`
